import { useMutation } from "@tanstack/react-query"
import highlightsService from "services/highlights.service"
import type {
	TCreateFigureHighlightRequest,
	TCreateFreehandHighlightRequest,
	THighlightShapeType,
} from "types/elevationReferences.type"

export const useCreateFigureHighlight = () => {
	return useMutation({
		mutationKey: ["createFigureHighlight"],
		mutationFn: ({ quotationId, body }: { quotationId: number; body: TCreateFigureHighlightRequest }) =>
			highlightsService.createFigureHighlight(quotationId, body),
	})
}

// REQ-400 #1324 — the freehand counterpart. Its own hook rather than a branch inside the figure one:
// the two endpoints take different bodies and return different shapes.
export const useCreateFreehandHighlight = () => {
	return useMutation({
		mutationKey: ["createFreehandHighlight"],
		mutationFn: ({ quotationId, body }: { quotationId: number; body: TCreateFreehandHighlightRequest }) =>
			highlightsService.createFreehandHighlight(quotationId, body),
	})
}

// One delete for both kinds — `shapeType` picks the backend table (see the service's own comment).
export const useDeleteHighlight = () => {
	return useMutation({
		mutationKey: ["deleteHighlight"],
		mutationFn: ({
			quotationId,
			highlightId,
			shapeType,
		}: {
			quotationId: number
			highlightId: number
			shapeType: THighlightShapeType
		}) => highlightsService.deleteHighlight(quotationId, highlightId, shapeType),
	})
}
